export default __webpack_public_path__ + "static/media/38_4_1.4916b53f.png";